import { Route } from '@apps-common/types/routes'
import { Notifications, Settings, Site } from '@apps-my-monitoring/pages'

// top level routes

export const ROUTE_SITES: Route = {
  key: 'sites',
  label: 'Sites',
  path: '/sites',
  component: Site,
  breadcrumbs: [{ label: 'Site', icon: 'sites' }],
  icon: 'stack',
  type: 'private',
  buildPath: (siteId?: string) => (siteId ? `/sites?siteId=${encodeURIComponent(siteId)}` : '/sites')
}

export const ROUTE_NOTIFICATIONS: Route = {
  key: 'notifications',
  label: 'Notifications',
  description: 'View your alerts and updates',
  path: '/notifications',
  component: Notifications,
  breadcrumbs: [{ label: 'Notifications', icon: 'sbNotifications' }],
  icon: 'sbNotifications',
  type: 'private',
  buildPath: () => '/notifications'
}

export const ROUTE_SETTINGS: Route = {
  key: 'settings',
  label: 'Settings',
  description: 'Manage your preferences',
  path: '/settings',
  component: Settings,
  breadcrumbs: [{ label: 'Settings', icon: 'sbSettings' }],
  icon: 'sbSettings',
  type: 'private',
  buildPath: () => '/settings'
}

export const SIDEBAR_ROUTES: Route[] = [ROUTE_NOTIFICATIONS, ROUTE_SETTINGS]

export const PRIVATE_ROUTES: Route[] = [ROUTE_SITES, ROUTE_NOTIFICATIONS, ROUTE_SETTINGS]
